import { useContext, useEffect, useState } from "react";
import DocumentsTable from "../../../components/DocumentsSettings/DocumentsTable/DocumentsTable";
import SearchBar from "../../../components/DocumentsSettings/SearchBar/SearchBar";
import Title from "../../../components/DocumentsSettings/Title/Title";
import Icon from "../../../components/Icon/Icon";
import styles from "./DocumentLibrary.module.css";
import { Link, useLocation } from "react-router-dom";
import Pagination from "../../../components/DocumentsSettings/DocumentsTable/Pagination/Pagination";

import {
  type IGetAllTemplatesParams,
  type IGetAllTemplatesResponse,
} from "../../../shared/types/templates.types";
import api from "../../../api/api";
import ConfirmActionModal from "../../../components/ConfirmActionModal/ConfirmActionModal";
import { LoaderContext } from "../../../shared/Contexts/Loader/LoaderContext";

const DocumentLibrary = () => {
  const { isLoading } = useContext(LoaderContext);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [filter, setFilter] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);

  const [
    isConfirmDeletePropertyModalOpen,
    setIsConfirmDeletePropertyModalOpen,
  ] = useState(false);

  const [templatesResponse, setTemplatesResponse] =
    useState<IGetAllTemplatesResponse | null>(null);
  const location = useLocation();

  useEffect(() => {
    handleFetchTemplates({
      limit: 8,
      page: currentPage,
      search: filter,
    });
  }, [currentPage, filter]);
  useEffect(() => {
    console.log(templatesResponse);
  }, [templatesResponse]);

  const isEditLinkDisabled = selectedIds.length !== 1;
  const isDeleteButtonDisabled = selectedIds.length === 0;

  const handleFetchTemplates = async (params: IGetAllTemplatesParams) => {
    try {
      const data = await api.TemplategetAllTemplates(params);
      setTemplatesResponse(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheckboxChange = (id: string): void => {
    if (selectedIds.includes(id)) {
      const newIds = selectedIds.filter((itemId) => itemId !== id);
      setSelectedIds(newIds);
    } else {
      const newIds = [...selectedIds, id];
      setSelectedIds(newIds);
    }
  };
  const handleDeleteDocuments = async () => {
    try {
      const deletedIdsResponse = await api.deleteTemplates({
        ids: selectedIds,
      });

      if (deletedIdsResponse.success === false) {
        throw new Error(`failed deleting templates with ids ${selectedIds}!`);
      }
      setTemplatesResponse((prev) => {
        if (!prev) return prev; // защита от null/undefined

        return {
          ...prev,
          data: prev.data.filter(
            (template) => !selectedIds.includes(template.id)
          ),
        };
      });

      setSelectedIds([]);
    } catch (error) {
      alert(
        `Some error accused during deleting templates with ids ${selectedIds}!`
      );
      console.log(error);
    }
  };

  const handleCheckboxSelectAll = (): void => {
    if (templatesResponse?.total === 0 || templatesResponse === null) return;
    const allVisibleIds = templatesResponse.data.map((doc) => doc.id);
    const areAllSelected = allVisibleIds.every((id) =>
      selectedIds.includes(id)
    );

    if (areAllSelected) {
      setSelectedIds((prev) =>
        prev.filter((id) => !allVisibleIds.includes(id))
      );
    } else {
      const newIds = [...selectedIds, ...allVisibleIds];
      setSelectedIds(newIds);
    }
  };

  const titles = ["Tipo de Documento", "Escaneados", "Fecha Ultimo Cambio"];

  const filteredRows = templatesResponse?.data.map((doc) => {
    const date = new Date(doc.updatedAt);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    const dateForTable = `${day} / ${month} / ${year}`;

    return {
      id: doc.id,
      properties: [doc.name, doc.countScanned, dateForTable],
    };
  });
  return (
    <div className={styles.container}>
      <Title title="Biblioteca de Documentos" className={styles.title} />
      <SearchBar
        handleSearch={setFilter}
        className={styles.searchbar}
        placeholder="Buscar documento"
      />
      <ul className={styles.actionsList}>
        <li>
          <Link
            className={
              isEditLinkDisabled
                ? styles.editLinkContainerDisabled
                : styles.editLinkContainer
            }
            to={isEditLinkDisabled ? "" : `/edit-type/${selectedIds[0]}`}
            state={{ from: location.pathname }}
          >
            Editar Propiedades
            <Icon name="document-edit" size={20} />
          </Link>{" "}
        </li>
        <li>
          <button
            className={styles.button}
            onClick={() => {
              setIsConfirmDeletePropertyModalOpen(true);
            }}
            disabled={isDeleteButtonDisabled}
          >
            <span>Eliminar Documento</span>{" "}
            <Icon name="document-failure" size={20} />
          </button>
        </li>
        <li>
          <Link
            to={"/create-type"}
            className={styles.createButton}
            state={{ from: location.pathname }}
          >
            <span>Crear Documento</span>{" "}
            <Icon name="document-create" size={20} />
          </Link>
        </li>
      </ul>
      {templatesResponse?.total ? (
        <>
          <div>
            <DocumentsTable
              titles={titles}
              documents={filteredRows}
              selectedIds={selectedIds}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxSelectAll={handleCheckboxSelectAll}
            />
            <Pagination
              totalPages={templatesResponse.totalPages}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </>
      ) : (
        !isLoading && <>Datos no encontrados {":("}</>
      )}
      <ConfirmActionModal
        isOpen={isConfirmDeletePropertyModalOpen}
        onRequestClose={() => {
          setIsConfirmDeletePropertyModalOpen(false);
        }}
        modalTitle="Eliminar documento"
        modalText="¿Está seguro que desea eliminar este documento?, tendrá que crear el documento nuevamente para que pueda ser digitalizado"
        cancelActionText="Cancelar"
        cancelActionHandler={() => {
          setIsConfirmDeletePropertyModalOpen(false);
        }}
        confirmActionText="Eliminar documento"
        confirmActionHandler={() => {
          handleDeleteDocuments();
          setIsConfirmDeletePropertyModalOpen(false);
        }}
      />
    </div>
  );
};

export default DocumentLibrary;
